import React from 'react';
import styled from 'styled-components';

export interface ButtonWrapperProps
  extends React.ButtonHTMLAttributes<HTMLButtonElement> {}

const ButtonWrapper = ({
  children,
  onClick,
  ...otherProps
}: ButtonWrapperProps) => {
  const onClickHandler = ({
    e,
    callback,
  }: {
    e: React.MouseEvent<HTMLButtonElement>;
    callback: any;
  }) => {
    e.stopPropagation();
    callback && callback();
  };

  return (
    <Button
      {...(otherProps as any)}
      onClick={(e) => onClickHandler({ e, callback: onClick })}
    >
      {children}
    </Button>
  );
};

export default ButtonWrapper;

const Button = styled.button`
  margin: 0;
  display: flex;
  width: 100%;
  height: 100%;
  outline-width: 0;
  border-width: 0;
  text-align: start;
  background-color: transparent;
  cursor: pointer;
  padding: 0;
`;
